import { isEmpty } from 'lodash-es';

import { Props } from './MDPModalWrapper';

type Section = Queries.ContentfulSection001 & {
  __typename: string;
};

type CTAType = Queries.ContentfulCallToAction001 & {
  __typename: string;
};
export const parseDisclaimerWrapper = (screener: any): Props | null => {
  if (!screener) {
    return null;
  }
  const { metadata, options, sections } = screener;
  /**
   * @deprecated: displayName is used to get the title of the modal. Instead of the title field in the metadata
   */
  const displayName = screener?.displayName;
  let isMDPModal = true;

  const bodies = getSections(sections);
  const cta = getCta(sections);

  let callToAction;
  if (cta?.label && cta?.url) {
    callToAction = {
      text: cta?.label,
      url: cta?.url,
    };
  }

  if (options) {
    isMDPModal = options.length === 0;
  }

  if (
    isEmpty(bodies) ||
    !bodies[0].body?.raw ||
    !displayName ||
    !callToAction ||
    !isMDPModal
  ) {
    return null;
  }

  /**
   * Keep backwards compatibility with the title field
   */
  const title = metadata?.title || displayName;
  return {
    body: bodies[0].body,
    body2: bodies[1]?.body || undefined,
    callToAction: callToAction,
    title,
    metadata: metadata,
  };
};

function getSections(sections: Section[]): Section[] {
  return sections
    ? sections.filter(
        (section: Section) => section.__typename === 'ContentfulSection001',
      )
    : [];
}
function getCta(sections: Section[]): CTAType | undefined {
  return sections
    ? (sections?.find(
        (section: Section) =>
          section.__typename === 'ContentfulCallToAction001',
      ) as CTAType | undefined)
    : undefined;
}
